<div id="full-width-modal-modalNewConversationTitle" class="modal fade show" tabindex="-1"
  aria-labelledby="modalNewConversationTitle" style="display: block;" aria-modal="true" role="dialog" #modalContainer>
  <div class="modal-dialog modal-dialog-scrollable modal-full-width">
    <div class="modal-content">
      <div class="modal-header" [ngClass]="
          selectedChannel?.type === 'CLOUD_API' ? 'flex-column gap-2' : ''
        ">
        @if (selectedChannel?.type !== 'CLOUD_API') {
        <h4 class="modal-title" id="modalNewConversationTitle">
          {{ 'attendance.newConversation.fillData' | translate }}
        </h4>
        }

        <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>

        @if (selectedChannel?.type === 'CLOUD_API') {
        <div class="w-100 custom-display-title">
          <i class="ri-message-3-line"></i>
          <strong>{{ 'attendance.newConversation.almostThere' | translate }}</strong>
        </div>

        <div class="row justify-content-center col-8">
          <div class="horizontal-steps mt-2 mb-4 pb-2">
            <div class="horizontal-steps-content">
              <div class="step-item" [ngClass]="step === 1 ? 'current' : ''">
                <span class="h5">{{ 'attendance.newConversation.fillData' | translate }}</span>
              </div>
              <div class="step-item" [ngClass]="step === 2 ? 'current' : ''">
                <span class="h5">{{ 'attendance.newConversation.selectTemplate' | translate }}</span>
              </div>
              <div class="step-item" [ngClass]="step === 3 ? 'current' : ''">
                <span class="h5">{{ 'attendance.newConversation.fillVariables' | translate }}</span>
              </div>
            </div>
            <div class="process-line" [ngStyle]="{
                width: step === 1 ? 0 : step === 2 ? '49%' : '100%'
              }"></div>
          </div>
        </div>
        }
      </div>

      <div class="modal-body custom-scroll-bar">
        <div [hidden]="step >= 2">
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label class="form-label">{{ 'attendance.newConversation.selectChannel' | translate }}</label>
              <mat-select class="form-control" (selectionChange)="selectChannel($event.value)"
                [placeholder]="'attendance.newConversation.selectChannelPlaceholder' | translate"
                [(ngModel)]="selectedChannel" #channel>
                @for (channel of channels; track channel) {
                <mat-option [value]="channel">
                  {{ channel.name }}
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="col-lg-6 mb-3" [ngStyle]="{ opacity: listDepartments?.length === 0 ? '0.4' : 1 }">
              <label class="form-label">{{ 'attendance.newConversation.selectDepartment' | translate }}</label>
              <mat-select class="form-control" (selectionChange)="selectDepartment($event.value)" #department
                [placeholder]="'attendance.newConversation.selectDepartmentPlaceholder' | translate">
                @for (department of listDepartments; track department) {
                <mat-option [value]="department">
                  {{ department.name }}
                </mat-option>
                }
              </mat-select>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <label class="form-label">{{ 'attendance.newConversation.selectContact' | translate }}</label>
              @if(!selectedContact) {
              <contact-list-component (onSelect)="onContactSelected($event)" />
              } @else {
              <div class="card-body table-responsive custom-rounded-table">
                <table class="table table-centered mb-0">
                  <thead>
                    <tr>
                      <th class="text-primary-emphasis">{{ 'attendance.newConversation.name' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'attendance.newConversation.email' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'attendance.newConversation.phone' | translate }}</th>
                      @if (!data?.contactId) {
                      <th class="text-primary-emphasis">
                        <span class="sr-only"></span>
                      </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row">
                      <td class="table-user">
                        <img class="me-2 rounded-circle" [alt]="selectedContact.name"
                          [src]="getContactImage(selectedContact)" (error)="onImageError($event)" />
                        <strong class="text-truncate">{{
                          selectedContact.name
                          }}</strong>
                        @if (selectedContact.blockedChannels &&
                        selectedContact.blockedChannels.length > 0) {
                        <span class="text-muted whitespace-nowrap">{{ 'attendance.newConversation.blocked' | translate }}</span>
                        }
                      </td>
                      <td>
                        {{ selectedContact.email ?? "-" }}
                      </td>
                      <td>
                        {{ getMaskedPhone(selectedContact.phone) }}
                      </td>
                      @if (!data?.contactId) {
                      <td class="custom-button-remove">
                        <button class="btn btn-danger" (click)="removeContact()">
                          <i class="ri-close-line"></i>
                          {{ 'attendance.newConversation.remove' | translate }}
                        </button>
                      </td>
                      }
                    </tr>
                  </tbody>
                </table>
              </div>
              }
            </div>
          </div>
        </div>

        <div [hidden]="step === 1">
          @if (!selectedTemplate) {
          <wa-template [channel]="selectedChannel" (onSelectTemplate)="onSelectTemplate($event)" />
          } @if (selectedTemplate && variables) {
          <wa-template-message [contact]="selectedContact" [variables]="variables" [template]="selectedTemplate"
            (templateParams)="setTemplateMessage($event)" />
          }
        </div>
      </div>

      <div class="modal-footer">
        @if (step === 1) {
        <div class="d-flex justify-content-center w-100">
          <button type="button" class="btn rounded-pill btn-lg px-4" [ngClass]="{
              'btn-outline-primary': selectedChannel?.type === 'CLOUD_API',
              'btn-primary': selectedChannel?.type !== 'CLOUD_API'
            }" #btnNextStep (click)="initAttendance()">
            <span class="d-flex align-items-center gap-2">
              @if (selectedChannel?.type !== 'CLOUD_API') {
              <i class="ri-customer-service-2-line"></i>
              }
              <strong>{{ !loading ? getNameButton() : "" }}</strong>
              @if (selectedChannel?.type === 'CLOUD_API') {
              <i class="ri-arrow-right-line"></i>
              }
            </span>

            @if (loading) {
            <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
            }
          </button>
        </div>
        } @if (selectedChannel?.type === 'CLOUD_API' && step >= 2) {
        <button type="button" class="btn btn-outline-primary rounded-pill btn-lg px-4 me-auto" (click)="goToBack()">
          <i class="ri-arrow-left-line"></i>
          {{ 'attendance.newConversation.back' | translate }}
        </button>
        <button #btnSendTemplate class="btn btn-primary rounded-pill btn-lg px-4" (click)="sendTemplateMessage()"
          [disabled]="loading">
          @if(loading) {
          <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
          } @else {
          <i class="ri-customer-service-2-line"></i>
          {{ 'attendance.newConversation.startAttendance' | translate }} }
        </button>
        }
      </div>
    </div>
  </div>
</div>